import styled from "@emotion/styled";
import {TimePicker as MuiTimePicker, TimePickerProps} from "@mui/x-date-pickers";
import {COLORS} from "../../../constants/constants";
import {getTimezoneAbbreviation} from "../../../utils/General";
import {Dayjs} from "dayjs";

type TTimePickerProps = TimePickerProps<Dayjs | Date, boolean> & {
  isValid?: boolean;
  showTimeZone?: boolean;
  iconSize?: number;
};

const TimePicker = (props: TTimePickerProps) => {
  const timezoneAbbreviation = props.timezone ? getTimezoneAbbreviation(props.timezone) : undefined;
  return (
    <div data-testid="time-picker" style={{position: "relative", width: "100%"}}>
      <StyledTimePicker {...props} />
      {props.showTimeZone && (
        <span
          style={{
            position: "absolute",
            right: `${props.iconSize ? props.iconSize + 10 : 30}px`,
            top: "10px",
            fontSize: "12px",
            color: COLORS.TEXT_GRAY
          }}
        >
          {timezoneAbbreviation}
        </span>
      )}
    </div>
  );
};

export default TimePicker;

const StyledTimePicker = styled(MuiTimePicker)<{isValid?: boolean; iconSize?: number}>`
  width: 100%;

  .MuiInputBase-root {
    font-size: 14px !important;
    width: 100%;
    height: 32px !important;
    margin: 0 !important;
    background-color: ${COLORS.WHITE} !important;

    .MuiInputBase-input {
      padding: 8px !important;
      padding-right: 0 !important;
    }

    .MuiOutlinedInput-notchedOutline {
      border: ${(props) => (props.isValid !== false ? "solid 1px #dedede !important" : "solid 1px #cd4246 !important")};
    }

    ::placeholder {
      color: ${COLORS.COLOR_PLACE_HOLDER} !important;
    }
  }

  svg {
    font-size: ${(props) => props.iconSize || 20}px !important;
  }

  button {
    padding: 4px !important;
    margin: 0 2px 0 0 !important;
  }
`;
